/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs */

const en_admin_membership_confirmations_please_upgrade_subscription = /** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please upgrade your subscription`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const de_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const es_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const fr_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const it_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const pl_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const hu_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/** @type {(inputs: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs) => LocalizedString} */
const ro_admin_membership_confirmations_please_upgrade_subscription = en_admin_membership_confirmations_please_upgrade_subscription;

/**
* | output |
* | --- |
* | "Please upgrade your subscription" |
*
* @param {Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_please_upgrade_subscription = /** @type {((inputs?: Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Please_Upgrade_SubscriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "de") return de_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "es") return es_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "it") return it_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_please_upgrade_subscription(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_please_upgrade_subscription(inputs)
	return ro_admin_membership_confirmations_please_upgrade_subscription(inputs)
});
export { admin_membership_confirmations_please_upgrade_subscription as "admin.membership_confirmations.please_upgrade_subscription" }